// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3YqB4","title":"BackImages_title__2F_7l","images":"BackImages_images__1w-EC"};